import { Card, CardContent, CardFooter } from "@/components/ui/card";
import {
  ContentContainer,
  // ContentMenu,
  // ContentBody,
} from "@/pages/layouts/main-content";
import { useEffect, useState } from "react";
import { TwoEmbed } from "./etc/2embed";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { getData } from "@/lib/indexed-db";
import { useAuth } from "@/providers/auth-provider";

export function MainETC() {
  const { user } = useAuth();
  const [auth, setAuth] = useState("");
  const [selectedItem, setSelectedItem] = useState<string | null>(null);

  useEffect(() => {
    const handleAuth = async () => {
      const result = await getData("settings", user._id);
      setAuth(result?.data?.auth || "");
    };

    handleAuth();
  }, []);

  const renderItem = (title: string, desc: string) => {
    return (
      <Card
        className="w-full h-fit cursor-pointer"
        onClick={() => setSelectedItem(title)}
      >
        <CardContent className="flex justify-center items-center border-b p-4">
          <h2 className="text-lg font-semibold">{title}</h2>
        </CardContent>
        <CardFooter className="flex justify-center items-center border-b p-2 text-muted-foreground">
          <span>{desc}</span>
        </CardFooter>
      </Card>
    );
  };

  const renderPage = () => {
    if (selectedItem === "2embed") {
      return <TwoEmbed />;
    }
    return null;
  };

  return (
    <ContentContainer>
      {selectedItem ? (
        <div className="w-full h-full relative">
          <div className="absolute top-1 left-1">
            <Button
              size="icon"
              variant="outline"
              onClick={() => setSelectedItem(null)}
            >
              <ArrowLeft className="h-4 w-4" />
            </Button>
          </div>
          {renderPage()}
        </div>
      ) : (
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4 p-4">
          {auth === "FAMILY" && renderItem("2embed", "free movie, tv, anime")}
        </div>
      )}
    </ContentContainer>
  );
}
